module.exports = __webpack_public_path__ + "img/dimensie-kwaliteit_van_leven.8ceb599f.svg";